@if (variant === "avatar") {
  <!-- Global header trigger -->
  <button
    #userMenuButton
    type="button"
    class="med_profile-avatar-btn"
    [attr.aria-label]="'my_account' | translate"
    data-cy="med_header_profile_trigger"
    (click)="op.toggle($event)"
  >
    <p-avatar
      [style]="{ 'background-color': userData?.email | hexColor }"
      [label]="userData | userInitials"
      shape="circle"
      class="med_user-circle"
    >
    </p-avatar>
  </button>
} @else {
  <button
  #userMenuButton
  type="button"
  class="btn btn-sidebar w-100 justify-content-start position-relative"
  [ngClass]="{
    active: menuOpened || checkLinkActive([urlService.getProfilePageURL(), urlService.getBillingPageURL()]),
  }"
  (click)="op.toggle($event)"
  id="user-menu"
  [@avatarAnim]="isSidebarExpanded ? 'expanded' : 'collapsed'"
  aria-label="Open user menu"
>
  <div class="d-flex justify-content-between align-items-center w-100">
    <div class="med_avatar-wrapper hstack gap-3 overflow-hidden">
      @if (!isSidebarExpanded) {
        <app-icon icon="user" class="icon-light flex-shrink-0 w-100" />
      }
      @if (isSidebarExpanded) {
        <p-avatar
          [style]="{ 'background-color': userData?.email | hexColor }"
          [label]="userData | userInitials"
          shape="circle"
          class="med_user-circle flex-shrink-0"
        >
        </p-avatar>
      }
      @if (isSidebarExpanded) {
        <div class="vstack med_avatar-data">
          <p class="xxl-body bold text-truncate text-start w-100">
            {{ userData?.first_name + " " + userData?.last_name }}
          </p>
          <p class="l-body text-truncate text-start w-100">{{ userData?.email }}</p>
        </div>
      }
    </div>

    @if (menuOpened) {
      <div class="med_popover-arrow position-absolute"></div>
    }
  </div>
  </button>
}

<p-popover
  #op
  (onShow)="menuOpened = true"
  (onHide)="menuOpened = false"
  class="med_popover-panel position-relative"
  [styleClass]="variant === 'avatar' ? 'med_header-popover' : ''"
>
  @if (deviceType.isDesktop || variant === "avatar") {
    <div
      class="med_panel-container"
      [class.med_header-panel-container]="variant === 'avatar'"
      [ngStyle]="panelPosition"
      (mouseenter)="onPopoverMouseEnter()"
      (mouseleave)="onPopoverMouseLeave()"
    >
      <div class="med_panel-wrapper vstack pt-3" [class.med_header-panel]="variant === 'avatar'">
        <!-- User Info. Only for the header trigger — the sidebar row already
             shows the name and email, so repeating them there is noise. -->
        @if (variant === "avatar") {
          <div class="med_profile-identity d-flex align-items-center gap-3 px-3 pb-3">
            <p-avatar
              [style]="{ 'background-color': userData?.email | hexColor }"
              [label]="userData | userInitials"
              shape="circle"
              class="med_user-circle"
              size="large"
            >
            </p-avatar>

            <div class="text-start overflow-hidden">
              <p class="med_profile-name text-truncate m-0">{{ userName }}</p>
              <p class="med_profile-email text-truncate m-0">{{ userEmail }}</p>
            </div>
          </div>
        }

        <!-- Trial Plan Section -->
        @if (["trialing", "paused"].includes(companySubscription?.status || "") && isWorkspaceAdmin) {
          <div class="med_plan-border mx-3 mb-2">
            <div class="med_plan position-relative px-3 py-2 text-start">
              <a
                href="javascript:void(0);"
                class="m-body medium link mb-1"
                (click)="goToUpgradePlan(); op.toggle($event)"
                id="upgrade_plan"
              >
                {{ "upgrade_now" | translate }}
              </a>
            </div>
          </div>
        }

        <!-- Active Subscription Section -->
        @if (
          (companySubscription?.status === "active" || companySubscription?.pause_collection !== null) &&
          isWorkspaceAdmin
        ) {
          <div class="mx-3 mb-2">
            <div class="med_plan border px-3 py-2 text-start">
              <p class="xl-body medium pt-1 mb-1">{{ subscriptionName }}</p>
              <a
                href="javascript:void(0);"
                class="m-body medium link mb-1"
                (click)="goToSubscription(); op.toggle($event)"
              >
                {{ "manage_plan" | translate }}
              </a>
            </div>
          </div>
        }

        <!-- Menu Options -->
        <button
          type="button"
          class="btn btn-menu w-100 ps-4 py-3 fw-normal"
          [ngClass]="{ active: checkLinkActive([urlService.getProfilePageURL()]) }"
          (click)="goToMyAccount(); op.toggle($event)"
        >
          <app-icon icon="user" />
          {{ "my_account" | translate }}
        </button>

        @if (companySubscription?.status === "active" && isWorkspaceAdmin) {
          <button
            type="button"
            class="btn btn-menu w-100 ps-4 py-3 fw-normal"
            [ngClass]="{ active: checkLinkActive([urlService.getBillingPageURL()]) }"
            (click)="goToSubscription(); op.toggle($event)"
          >
            <app-icon icon="money" />
            {{ "subscription" | translate }}
          </button>
        }

        <!-- Logout Button -->
        <div class="border-top">
          <button type="button" class="btn btn-menu w-100 ps-4 fw-normal py-3" (click)="logout(); op.toggle($event)">
            <app-icon icon="logout" />
            {{ "logout" | translate }}
          </button>
        </div>
      </div>
    </div>
  }
  @if (!deviceType.isDesktop && variant !== "avatar") {
    <div
      class="med_panel-wrapper vstack gap-2"
      (mouseenter)="onPopoverMouseEnter()"
      (mouseleave)="onPopoverMouseLeave()"
    >
      <!-- User Info -->
      <div class="d-flex align-items-center gap-3 ps-4 pt-3 pe-3 pb-2" (click)="goToMyAccount(); op.toggle($event)">
        <p-avatar
          [style]="{ 'background-color': userData?.email | hexColor }"
          [label]="userData | userInitials"
          shape="circle"
          class="med_user-circle"
          size="large"
        >
        </p-avatar>

        <div class="text-start">
          <p class="xxl-body bold">{{ userName }}</p>
          <p class="l-body">{{ userEmail }}</p>
        </div>
      </div>

      <!-- Trial Plan Section -->
      @if (["trialing", "paused"].includes(companySubscription?.status || "") && isWorkspaceAdmin) {
        <div class="med_plan-border mx-3">
          <div class="med_plan position-relative px-3 py-2 text-start">
            <div class="med_badge">{{ trialTime }} {{ "days_left" | translate }}</div>
            <p class="xl-body medium pt-1 mb-1">{{ "__medullar_trial__" | translate }}</p>
            <a
              href="javascript:void(0);"
              class="m-body medium link mb-1"
              (click)="goToUpgradePlan(); op.toggle($event)"
              id="upgrade_plan"
            >
              {{ "upgrade_now" | translate }}
            </a>
          </div>
        </div>
      }

      <!-- Active Subscription Section -->
      @if (
        (companySubscription?.status === "active" || companySubscription?.pause_collection !== null) && isWorkspaceAdmin
      ) {
        <div class="mx-3">
          <div class="med_plan border px-3 py-2 text-start">
            <p class="xl-body medium pt-1 mb-1">{{ subscriptionName }}</p>
            <a
              href="javascript:void(0);"
              class="m-body medium link mb-1"
              (click)="goToSubscription(); op.toggle($event)"
            >
              {{ "manage_plan" | translate }}
            </a>
          </div>
        </div>
      }

      <!-- Menu Options -->
      <button
        type="button"
        class="btn btn-menu w-100 ps-4"
        [ngClass]="{ active: checkLinkActive([urlService.getProfilePageURL()]) }"
        (click)="goToMyAccount(); op.toggle($event)"
      >
        <app-icon icon="user" />
        {{ "my_account" | translate }}
      </button>

      @if (companySubscription?.status === "active" && isWorkspaceAdmin) {
        <button
          type="button"
          class="btn btn-menu w-100 ps-4"
          [ngClass]="{ active: checkLinkActive([urlService.getBillingPageURL()]) }"
          (click)="goToSubscription(); op.toggle($event)"
        >
          <app-icon icon="money" />
          {{ "subscription" | translate }}
        </button>
      }

      <!-- Logout Button -->
      <div class="py-2 border-top">
        <button type="button" class="btn btn-menu w-100 ps-4" (click)="logout(); op.toggle($event)">
          <app-icon icon="logout" />
          {{ "logout" | translate }}
        </button>
      </div>
    </div>
  }
</p-popover>
